export const PENDING = 'dt:inventory_status:pending';
export const PICK = 'dt:inventory_status:pick';
export const PACK = 'dt:inventory_status:pack';
export const SHIP = 'dt:inventory_status:ship';
export const RECEIVED = 'dt:inventory_status:received';
export const PROCESSED = 'dt:inventory_status:processed';
export const CANCELLED = 'dt:inventory_status:cancelled';
export const ERROR = 'dt:inventory_status:error';


export const ALL = [
  { "id"           : "dt:inventory_status:pending",
    "id_ext"        : "3200000",
    "doc_type"      : "inventory_status",
    "name"          : "Pending",
    "short_name"    : "Pending",
    "active"        : true,
    "system_defined": true
  },
  { "id"           : "dt:inventory_status:pick",
    "id_ext"        : "3200001",
    "doc_type"      : "inventory_status",
    "name"          : "Pick",
    "short_name"    : "Pick",
    "active"        : true,
    "system_defined": true
  },
  { "id"           : "dt:inventory_status:pack",
    "id_ext"        : "3200002",
    "doc_type"      : "inventory_status",
    "name"          : "Pack",
    "short_name"    : "Pack",
    "active"        : true,
    "system_defined": true
  },
  { "id"           : "dt:inventory_status:ship",
    "id_ext"        : "3200003",
    "doc_type"      : "inventory_status",
    "name"          : "Ship",
    "short_name"    : "Ship",
    "active"        : true,
    "system_defined": true
  },
  { "id"           : "dt:inventory_status:received",
    "id_ext"        : "3200004",
    "doc_type"      : "inventory_status",
    "name"          : "Received",
    "short_name"    : "Received",
    "active"        : true,
    "system_defined": true
  },
  { "id"           : "dt:inventory_status:cancelled",
    "id_ext"        : "3200005",
    "doc_type"      : "inventory_status",
    "name"          : "Cancelled",
    "short_name"    : "Cancelled",
    "active"        : true,
    "system_defined": true
  },
  { "id"           : "dt:inventory_status:processed",
    "id_ext"        : "3200006",
    "doc_type"      : "inventory_status",
    "name"          : "Processed",
    "short_name"    : "Processed",
    "active"        : true,
    "system_defined": true
  },
  { "id"           : "dt:inventory_status:error",
    "id_ext"        : "3200007",
    "doc_type"      : "inventory_status",
    "name"          : "Error",
    "short_name"    : "Error",
    "active"        : true,
    "system_defined": true
  }
];